<template>
  <div class="flex items-center">
    <dl class="flex-grow my-0 md:flex mr-base">
      <dt
        class="mb-xs md:mb-0 font-bold text-14 text-black md:text-16 md:flex-shrink-0 md:w-{250px} flex flex-col"
      >
        <span
          class="flex items-center"
          data-test="title"
        >
          {{ title }}
          <span
            v-if="hasSlot('title-extra')"
            data-test="title-extra"
          >
            <slot name="title-extra" />
          </span>
        </span>
        <span
          v-if="subtitle"
          class="text-10 font-normal mt-xs text-black"
          data-test="subtitle"
        >
          {{ subtitle }}
        </span>
      </dt>

      <dd
        v-if="hasSlot('default')"
        class="ml-0 md:ml-xl font-normal flex items-center"
        data-test="content"
      >
        <slot />
      </dd>
    </dl>

    <div class="md:flex md:flex-wrap md:items-center md:gap-base">
      <div
        v-if="hasSlot('info')"
        data-test="info"
        class="mb-sm md:mb-0"
      >
        <slot name="info" />
      </div>

      <div data-test="controls">
        <slot name="controls">
          <ButtonLink
            :to="to"
            size="small"
            variant="secondary"
            :disabled="disabled"
            :dataEc="dataEc"
            :dataEt="dataEt"
          >
            {{ $t('functional.edit') }}
          </ButtonLink>
        </slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useSlots } from 'vue';

import ButtonLink from '@/components/library/links/ButtonLink.vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: false,
  },
  to: {
    type: [String, Object],
    required: false,
  },
  disabled: {
    type: Boolean,
    required: false,
  },
  dataEc: {
    type: String,
    required: true,
  },
  dataEt: {
    type: String,
    required: true,
  },
});

const slots = useSlots();

function hasSlot(slot) {
  return !!slots[slot];
}
</script>
